
import HintTooltip from '@/components/helper/HintTooltip.vue'
import IconHelpSupport from '@svg/IconHelpSupport.svg'
import { Component, Vue } from 'vue-property-decorator'

// JP: All lang="ts" scripts must define components even if empty.
// If you delete these lines you will get the error (At "vue": "^2.6.10" and "vuetify": "^2.2.1"):
// TypeError: Cannot set property 'components' of undefined
//    at installComponents (installComponents.js:11)

@Component({
  components: {
    'hint-tooltip': HintTooltip,
    'icon-help-support': IconHelpSupport,
  },
  metaInfo() {
    const isInviteSetupView = this.$route.query.invited === '1'

    return {
      title: `${isInviteSetupView ? 'Join your team' : 'Log in'} to access & create 3D presentations & more`,
      meta: [
        {
          name: 'description',
          content: `${
            isInviteSetupView ? 'Join your team' : 'Log in'
          } to manage your team users, 3D assets, branding, and sharing settings.`,
        },
      ],
    }
  },
})
export default class PreLoginVue extends Vue {
  private isInviteSetupView: boolean = false

  public $refs!: Vue['$refs'] & {
    loginTooltip: HintTooltip
  }

  protected created() {
    this.isInviteSetupView = this.$route.query.invited === '1'
  }

  protected mounted() {
    if (this.isInvokingLogin) {
      this.handleLoginAction()
    }
  }

  private get isInvokingLogin(): boolean {
    return this.$route.query != null && this.$route.query.invoke_login === 'true'
  }

  private get pageHeading(): string {
    return this.isInviteSetupView ? 'Join your team' : `Team dashboard${this.isEUDomain ? ' (EU)' : ''}`
  }

  private get pageCopy(): { [key: string]: string } {
    return {
      description: this.isInviteSetupView
        ? `You've been invited to join a team in JigSpace.`
        : 'Log in to manage your team users, 3D assets, branding, and sharing settings.',
      infoCopyHtml: this.isInviteSetupView
        ? `Set a new password to complete your setup.`
        : `Don't have an account? <a href="https://account.jig.space/signup" class="login__link" target="_blank">Get started</a>.`,
    }
  }

  private get isEUDomain(): boolean {
    // return false
    return process.env.VUE_APP_WEB_DOMAIN != null && process.env.VUE_APP_WEB_DOMAIN.includes('eu.jig.space')
  }

  private get showHintCopy(): boolean {
    return this.isInviteSetupView || !this.isEUDomain
  }

  private get ctaCopy(): string {
    return this.isInviteSetupView ? 'Finish setup' : 'Log in'
  }

  private get altLoginRedirect(): string {
    const usLoginEnv: string =
      process.env.VUE_APP_US_LOGIN_ENV != null && process.env.VUE_APP_US_LOGIN_ENV !== '' ? `.${process.env.VUE_APP_US_LOGIN_ENV}` : ''

    return `https://dashboard${this.isEUDomain ? usLoginEnv : '.eu'}.jig.space/pre-login`
  }

  private handleLoginAction() {
    if (this.isInviteSetupView) {
      // Trigger universal login with custom param attached,
      // so that universal loign form can show custom copy for better UX.
      this.$auth0.loginWithRedirect({
        appState: { target: '/my-jigs' },
        prompt: 'login',
        authorizationParams: {
          rememberLastLogin: false,
          isInvitedSetupView: true,
          allowSignUp: false,
          altLoginUrl: `${this.altLoginRedirect}?invoke_login=true`,
        },
      })
    } else {
      this.$router.push({ path: '/my-jigs' })
    }
  }

  private toggleTooltip() {
    this.$refs.loginTooltip.toggleHintTooltip()
  }
}
